module.exports = __webpack_public_path__ + "static/media/iphone3-4.f6f8471e.png";